import { ReactComponent as DateIcon } from "assets/icons/CustomDateIconGray.svg";
import TimeIcon from "assets/icons/TimeIcon.png";
import AuthService from "Lib/API/Auth";
import EvevntService from "Lib/API/Events";
import { ReactComponent as CopyIconGray } from "assets/icons/CopyIconGray.svg";
import { ReactComponent as Instagram } from "assets/icons/InstagramColorful.svg";
import { ReactComponent as Facebook } from "assets/icons/facebookColorful.svg";
import { ReactComponent as Twitter } from "assets/icons/twitter-link.svg";
import cuid from "cuid";
import * as calculation from "helper/CalculateEvent";
import { formatDate, setLocalizationMoment } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import { useMobileView } from "hook/mobileView/useMobileView";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import {
  setCounterTicket,
  setTicketTypeList,
  setTicketTypeVariants,
} from "services/api/events";
import thousands from "thousands";
import {
  ContactInfo,
  ContactInfoDetails,
  ContactTitle,
  DashLine,
  DateChip,
  DatesRow,
  Description,
  DescriptionText,
  EventCaption,
  EventLogin,
  EventName,
  EventTitle,
  EventType,
  EventTypeDetails,
  EventTypeName,
  FixedBottomSection,
  MoreDatesChip,
  MultiDatesWrapper,
  Note,
  PayDetails,
  ReserveAction,
  ReserveButton,
  ReserveLoginButton,
  RightSideContent,
  RightSideWrappr,
  SocialIcons,
  TicketContainer,
  TotalPay,
} from "./Theme";
import TicketCards from "./TicketCards";
import LoginModal from "../ReservationEventPage/PersonalDetailsCard/LoginModal";
import { toastr } from "react-redux-toastr";
import {
  getAccessTokenSilently,
  getAuthenticated,
  logout,
} from "utils/functions";
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";

export const RightSide = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const currency = getCurrency();
  const { isMobile } = useMobileView();
  const isAuthenticated = getAuthenticated();
  const { enqueueSnackbar } = useSnackbar();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [authTick, setAuthTick] = useState(0);

  const [loading, setLoading] = useState(false);
  const [ticketData, setTicketData] = useState([]);
  const [ticketsTypeList, setTicketsTypeList] = useState([]);
  const { numberOfTickets } = useSelector((state) => state?.Events);
  const { eventData } = useSelector((state) => state?.Events);

  const memberPortal = localStorage.getItem("memberPortal") === "true" || false;

   const entrySource = sessionStorage.getItem("entrySource");
  const isFromApp = entrySource === "app";

  const totalTicketVariant = ticketData.flatMap((group) => group.variantInfo || []);
  const grossTicketTotal = totalTicketVariant.reduce(
    (sum, v) => sum + (v.amount || 0) * (v.selectedQuantity || 0),
    0
  );
  const viewPayDetails = !eventData.freeEvent && grossTicketTotal > 0;
  const checkAndModifyUrl = (url) => {
    if (url.startsWith("http://")) {
      return url.replace("http://", "https://");
    } else if (!url.startsWith("https://")) {
      return `https://${url}`;
    }
    return url;
  };

  const handleDifferanceDate = () => {
    const now = new Date();
    const end = new Date(eventData?.eventEndDate);

    const diffMs = end - now;

    if (diffMs <= 0) {
      return;
    }

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 24) {
      return diffHours === 1 ? (
        <span>{diffHours} Hour left!</span>
      ) : (
        <span>{diffHours} Hours left!</span>
      );
    }

    return diffDays === 1 ? (
      <span>{diffDays} Day left!</span>
    ) : (
      <span>{diffDays} Days left!</span>
    );
  };

  const isExpiredEvent = () => {
    const now = moment().tz("America/New_York");

    const start = moment(eventData?.eventStartDate).tz("America/New_York");
    const end = moment(eventData?.eventEndDate).tz("America/New_York");

    // Registration has not started yet
    if (now.isBefore(start)) return true;

    // Registration already ended
    if (now.isAfter(end)) return true;

    return false;
  };

  const isExpiredClass = () => {
    const now = moment().tz("America/New_York");

    const start = moment(eventData?.eventStartDate).tz("America/New_York");
    const end = moment(eventData?.eventEndDate).tz("America/New_York");

    // Registration has not started yet
    if (now.isBefore(start)) return true;

    // Registration already ended
    if (now.isAfter(end)) return true;

    return false;
  };

  const getToken = async () => {
    try {
      const subDomain = window.location.hostname.split(".")[0];
      const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
      await AuthService.generateToken(hostName).then((res) => {
        localStorage.setItem("eventToken", res?.token);
        localStorage.setItem("logoImgEvent", res?.logoImg);
        localStorage.setItem(
          "paymentMethodEvents",
          JSON.stringify(res?.paymentMethodCreditCard)
        );
        localStorage.setItem(
          "achPaymentMethodEvents",
          JSON.stringify(res?.paymentMethodAch)
        );
        localStorage.setItem("orgName", res?.orgName);
        localStorage.setItem("country", JSON.stringify(res?.country || {}));
        localStorage.setItem("memberPortal", res?.memberPortal || false);
        localStorage.setItem(
          "allowInstallments",
          res?.allowInstallments || false
        );

        setLocalizationMoment(res?.country?.local || "en");
        document.title = `${res?.orgName}`;
      });
    } catch (error) {
      enqueueSnackbar(error?.eventData?.message, {
        variant: "error",
      });
    }
  };

  const getTicketData = () => {
    let data = [];
    ticketData.forEach((group) => {
      (group.variantInfo || []).forEach((variant) => {
        if (variant.selectedQuantity) {
          data.push({
            id: group?._id,
            title: variant.name,
            numberOfTickets: variant.selectedQuantity,
          });
        }
      });
    });
    return data;
  };
  const handleReserveButton = async () => {
    if (
      !numberOfTickets?.length ||
      (!eventData?.allowNonMembers && !isAuthenticated)
    )
      return;
    if (numberOfTickets?.length > 20) {
      enqueueSnackbar(
        "You can only reserve up to 20 tickets at a time. Please reduce your selection and try again.",
        { variant: "error" }
      );
      return;
    }
    const body = {
      eventId: eventData?._id,
      ...(!eventData?.freeEvent ? { tickets: getTicketData() } : {}),
      ...(eventData?.freeEvent
        ? { numberOfTickets: numberOfTickets.length }
        : {}),
    };
    setLoading(true);
    try {
      const token = isAuthenticated
        ? await getAccessTokenSilently()
        : localStorage.getItem("eventToken");
      await EvevntService.reserveSeats(token, body).then((res) => {
        setLoading(false);
        dispatch(setTicketTypeVariants(
          eventData?.multiEventsType === "individual"
            ? (() => {
                const onRegPrice = eventData?.eventPricing?.prices?.find(
                  (p) => p?.type === "onRegistration"
                );
                return onRegPrice
                  ? [{
                      _id: onRegPrice._id,
                      name: onRegPrice.title || "Ticket",
                      amount: 0,
                      selectedQuantity: numberOfTickets.length,
                      installmentStatus: false,
                      installment: null,
                    }]
                  : [];
              })()
            : ticketData.flatMap((group) => (group.variantInfo || []).map((v) => ({ ...v, _id: group._id })))
        ));
        localStorage.setItem("reserveId", res?.result?._id);
        history.push(`/events/${params?.id}/reservation`);
      });
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });
      throw error;
    }
  };
  useEffect(() => {
    localStorage.removeItem("redirectUrl");
    if (!localStorage.getItem("eventToken")) getToken();
  }, []);

  useEffect(() => {
    let ticketGroups = [];
    if (eventData?.freeEvent) {
      ticketGroups = [
        {
          title: "Ticket",
          variantInfo: [
            {
              name: "Ticket",
              amount: 0,
              selectedQuantity: 0,
              infiniteQuantity:
                eventData?.eventDetails?.infiniteCapacity || false,
              quantity: eventData?.eventDetails?.maximumCapacity || undefined,
            },
          ],
        },
      ];
    } else {
      if (!eventData?.eventPricing?.prices?.length) return;
      const onRegistrationItems = eventData?.eventPricing?.prices?.filter(
        (item) => item?.type === "onRegistration"
      );
      if (onRegistrationItems?.length) {
        ticketGroups = onRegistrationItems.map((item) => ({
          ...item,
          variantInfo: item?.variant
            ? transformVariantInfoToArray(item?.variantInfo || {})
            : [
                {
                  name: item?.title,
                  infiniteQuantity:
                    eventData?.eventDetails?.infiniteCapacity || false,
                  amount: item?.amount,
                  selectedQuantity: 0,
                  quantity:
                    eventData?.eventDetails?.maximumCapacity || undefined,
                  forMemberOnly: item?.forMemberOnly || false,
                  reserveProduct: item?.reserveProduct || 0,
                },
              ],
        }));
      }
    }
    setTicketData(ticketGroups);
  }, [eventData?.eventPricing?.prices]);

  const handleQuantityChange = useCallback(
    (groupIndex, variantIndex, value, type) => {
      const newTicketData = ticketData.map((group, gi) => {
        if (gi !== groupIndex) return group;
        const newVariantInfo = [...group.variantInfo];
        newVariantInfo[variantIndex] = { ...newVariantInfo[variantIndex], selectedQuantity: value };
        return { ...group, variantInfo: newVariantInfo };
      });
      setTicketData(newTicketData);

      if (type === "increment") {
        handleAddTicketId(groupIndex, variantIndex);
      }

      if (type === "decrement") {
        handleRemoveTicketId(ticketData[groupIndex].variantInfo[variantIndex].id);
      }
    },
    [ticketData]
  );

  const handleAddTicketId = (groupIndex, variantIndex) => {
    const group = ticketData[groupIndex];
    const variant = group?.variantInfo[variantIndex];
    const newTicketTypeList = [...ticketsTypeList];
    const ticketId = cuid();
    newTicketTypeList.push({
      id: ticketId,
      name: variant?.name,
      quantity: variant?.selectedQuantity,
      amount: variant?.amount,
      ticketId: group?._id,
    });
    setTicketsTypeList(newTicketTypeList);
    dispatch(setCounterTicket([...numberOfTickets, ticketId]));
    dispatch(setTicketTypeList(newTicketTypeList));
  };

  const handleIndividualAddTicket = () => {
    if (!eventData?.allowNonMembers && !isAuthenticated) return;
    const ticketId = cuid();
    const newTicketTypeList = [...ticketsTypeList, {
      id: ticketId,
      name: "Ticket",
      quantity: numberOfTickets.length + 1,
      amount: 0,
      ticketId: eventData?._id,
    }];
    setTicketsTypeList(newTicketTypeList);
    dispatch(setCounterTicket([...numberOfTickets, ticketId]));
    dispatch(setTicketTypeList(newTicketTypeList));
  };

  const handleIndividualRemoveTicket = () => {
    if (!numberOfTickets.length) return;
    const newTicketTypeList = ticketsTypeList.slice(0, -1);
    const newNumberOfTickets = numberOfTickets.slice(0, -1);
    setTicketsTypeList(newTicketTypeList);
    dispatch(setCounterTicket(newNumberOfTickets));
    dispatch(setTicketTypeList(newTicketTypeList));
  };

  const handleRemoveTicketId = (ticketId) => {
    const newTicketTypeList = [...ticketsTypeList];
    const ticketTypeIndex = newTicketTypeList.findIndex(
      (ticket) => ticket.id === ticketId
    );
    newTicketTypeList.splice(ticketTypeIndex, 1);
    setTicketsTypeList(newTicketTypeList);
    const cloneNumberOfTickets = [...numberOfTickets];
    const ticketIndex = cloneNumberOfTickets.indexOf(ticketId);
    cloneNumberOfTickets.splice(ticketIndex, 1);
    dispatch(setCounterTicket(cloneNumberOfTickets));
    dispatch(setTicketTypeList(newTicketTypeList));
  };

  const transformVariantInfoToArray = useCallback((variantInfo) => {
    const newVariantInfo = [];
    if (Object.keys(variantInfo).length === 0) return newVariantInfo;
    for (const key in variantInfo) {
      newVariantInfo.push({
        name: key,
        quantity: variantInfo[key]?.quantity || "",
        infiniteQuantity: variantInfo[key]?.infiniteQuantity || false,
        reserveProduct: variantInfo[key]?.reserveProduct || 0,
        amount: variantInfo[key]?.amount || "",
        selectedQuantity: 0,
        forMemberOnly: variantInfo[key]?.forMemberOnly || false,
      });
    }
    return newVariantInfo;
  }, []);

  const handleReserveLogin = () => {
    if (isAuthenticated) {
      handleReserveLogout();
      return;
    }
    setLoginModalOpen(true);
  };

  const handleReserveLogout = () => {
    localStorage.clear();
    window.location.href = `/events/${params?.id}`;
    toastr.success("Success", "Successfully Logged out!");
  };

  const reserveLoginButton = useMemo(
    () =>
      isAuthenticated
        ? "Logout"
        : eventData?.allowNonMembers
        ? "Member? Log in here"
        : "Log in to sign up",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAuthenticated, eventData?.allowNonMembers]
  );

  const eventLogin = useMemo(() => (isAuthenticated ? "Logout" : "Login"), [
    isAuthenticated,
  ]);

  return (
    <>
    <LoginModal
      open={loginModalOpen}
      onClose={() => setLoginModalOpen(false)}
      onSuccess={() => {
        setLoginModalOpen(false);
        setAuthTick((t) => t + 1);
      }}
    />
    <RightSideWrappr isFromApp={isFromApp}>
      <RightSideContent>
        {memberPortal  && !(isFromApp&& isAuthenticated) &&  (
          <EventLogin>
            <ReserveLoginButton onClick={handleReserveLogin}>
              {eventLogin}
            </ReserveLoginButton>
          </EventLogin>
        )}

        <EventTitle>
          <EventName>{eventData?.eventName}</EventName>
          <EventCaption>
            {eventData?.alwaysAvailable ? (
              "Always Available"
            ) : (
              <span>
                Registration ends{" "}
                {formatDate({
                  date: eventData?.eventEndDate,
                  formatType: "defaultWithTimeEST",
                })}{" "}
                (EST)
              </span>
            )}
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px", marginTop: "4px", background: "none", padding: 0, marginLeft: 0, color: "inherit" }}>
              {isExpiredEvent()
                ? ""
                : !eventData?.alwaysAvailable && (
                    <div>{handleDifferanceDate()}</div>
                  )}
              {eventData?.multiEvents && eventData?.eventDetails?.eventType && (
                <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  backgroundColor: "rgba(37, 85, 239, 0.08)",
                  color: FontColors.Blue2555EF,
                  borderRadius: "6px",
                  padding: "3px 10px",
                  fontSize: Fonts.GeneralSmallLabelFont.fontSize,
                  fontWeight: FontWeights.Bold,
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                  letterSpacing: "0.01em",
                }}>
                  {eventData.eventDetails.eventType?.toLowerCase() === "online" ? (
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                      <circle cx="12" cy="12" r="10" stroke="#2555EF" strokeWidth="2"/>
                      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="#2555EF" strokeWidth="2"/>
                    </svg>
                  ) : (
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#2555EF" strokeWidth="2" strokeLinejoin="round"/>
                      <circle cx="12" cy="9" r="2.5" stroke="#2555EF" strokeWidth="2"/>
                    </svg>
                  )}
                  {eventData.eventDetails.eventType}
                </span>
              )}
            </div>
            {!eventData?.allowNonMembers && !isAuthenticated && (
              <div className="members-only-indicator">Members Only</div>
            )}
          </EventCaption>
        </EventTitle>

        {eventData?.multiEvents && eventData?.multiEventsDates?.length > 0 && (
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "10px",
            padding: "9px 14px",
            backgroundColor: "rgba(37, 85, 239, 0.06)",
            border: "1px solid rgba(37, 85, 239, 0.18)",
            borderRadius: "8px",
            fontSize: Fonts.GeneralLabelFont.fontSize,
            color: FontColors.Blue2555EF,
            fontWeight: Fonts.GeneralLabelFont.fontWeight,
            lineHeight: 1.4,
          }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
              <rect x="3" y="4" width="18" height="18" rx="3" stroke="#2555EF" strokeWidth="2"/>
              <path d="M16 2v4M8 2v4M3 10h18" stroke="#2555EF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>This is a multi-date event spanning <strong>{eventData.multiEventsDates.length} {eventData.multiEventsDates.length === 1 ? "session" : "sessions"}</strong>.</span>
          </div>
        )}
        <EventType isMultiDate={eventData?.multiEvents} style={{ marginTop: "12px", ...(!eventData?.multiEvents && { background: "transparent", boxShadow: "none" }) }}>
          <EventTypeDetails>
            {eventData?.multiEvents ? (
              <>
                <span style={{ marginBottom: 6 }}>Dates</span>
                {(() => {
                  const dates = eventData?.multiEventsDates || [];
                  const hasMore = dates.length > 6;
                  const isGrouped = eventData?.multiEventsType === "grouped";
                  const dateCard = (dateItem, idx) => {
                    const month = dateItem?.eventDate ? moment.utc(dateItem.eventDate).format("MMM").toUpperCase() : "";
                    const day   = dateItem?.eventDate ? moment.utc(dateItem.eventDate).format("DD") : "";
                    const year  = dateItem?.eventDate ? moment.utc(dateItem.eventDate).format("YYYY") : "";
                    const dow   = dateItem?.eventDate ? moment.utc(dateItem.eventDate).format("ddd").toUpperCase() : "";
                    const label = dateItem?.label || dateItem?.variantName || dateItem?.name || "";
                    return (
                      <div key={idx} style={{
                        background: "#fff",
                        border: "1px solid #E2E8F0",
                        borderRadius: 12,
                        padding: "10px 12px",
                        display: "flex",
                        gap: 12,
                        boxSizing: "border-box",
                        minWidth: 0,
                        overflow: "hidden",
                      }}>
                        <div style={{
                          background: "#EEF2FF",
                          borderLeft: "3px solid #2555EF",
                          borderRadius: 8,
                          padding: "8px 10px",
                          textAlign: "center",
                          minWidth: 48,
                          flexShrink: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 2,
                        }}>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Blue2555EF, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{month}</span>
                          <span style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: FontColors.Black, lineHeight: 1.1, opacity: 1 }}>{day}</span>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate64748B, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{year}</span>
                          <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate64748B, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{dow}</span>
                        </div>
                        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 3, justifyContent: "center" }}>
                          <div title={label ? label.charAt(0).toUpperCase() + label.slice(1) : `Session ${idx + 1}`} style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: FontColors.Slate0F172A, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {label ? label.charAt(0).toUpperCase() + label.slice(1) : `Session ${idx + 1}`}
                          </div>
                          <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, display: "flex", alignItems: "center", gap: 4 }}>
                            🕑 {formatDate({ date: dateItem?.eventDate, formatType: "timeUTC" })}
                          </div>
                        </div>
                      </div>
                    );
                  };
                  const grid = (
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                      gap: "8px",
                      width: "100%",
                    }}>
                      {dates.map((dateItem, idx) => dateCard(dateItem, idx))}
                    </div>
                  );
                  return hasMore ? (
                    <div style={{
                      maxHeight: "292px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      width: "100%",
                      scrollbarWidth: "thin",
                      scrollbarColor: "rgba(37,85,239,0.25) transparent",
                    }}>
                      {grid}
                    </div>
                  ) : grid;
                })()}
              </>
            ) : (
              (() => {
                const month = eventData?.date ? moment.utc(eventData.date).format("MMM").toUpperCase() : "";
                const day   = eventData?.date ? moment.utc(eventData.date).format("DD") : "";
                const year  = eventData?.date ? moment.utc(eventData.date).format("YYYY") : "";
                const dow   = eventData?.date ? moment.utc(eventData.date).format("ddd").toUpperCase() : "";
                return (
                  <div style={{
                    background: "#fff",
                    border: "1px solid #E2E8F0",
                    borderRadius: 12,
                    padding: "10px 12px",
                    display: "flex",
                    gap: 12,
                    boxSizing: "border-box",
                    width: "100%",
                  }}>
                    <div style={{
                      background: "#EEF2FF",
                      borderLeft: "3px solid #2555EF",
                      borderRadius: 8,
                      padding: "8px 10px",
                      textAlign: "center",
                      minWidth: 48,
                      flexShrink: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                    }}>
                      <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Blue2555EF, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{month}</span>
                      <span style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: FontColors.Black, lineHeight: 1.1, opacity: 1 }}>{day}</span>
                      <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate64748B, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{year}</span>
                      <span style={{ fontSize: Fonts.GeneralTinyFont.fontSize, fontWeight: FontWeights.SemiBold, color: FontColors.Slate64748B, letterSpacing: "0.06em", lineHeight: 1, opacity: 1 }}>{dow}</span>
                    </div>
                    <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 4, justifyContent: "center" }}>
                      <div style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: FontColors.Slate0F172A, opacity: 1 }}>
                        {formatDate({ date: eventData?.date, formatType: "defaultWithUTC" })}
                      </div>
                      <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, display: "flex", alignItems: "center", gap: 4, opacity: 1 }}>
                        🕑 {formatDate({ date: eventData?.date, formatType: "timeUTC" })}
                      </div>
                      {eventData?.eventDetails?.eventType && (
                        <span style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                          background: "rgba(37,85,239,0.08)",
                          color: FontColors.Blue2555EF,
                          borderRadius: 20,
                          padding: "2px 8px",
                          fontSize: Fonts.GeneralTinyFont.fontSize,
                          fontWeight: FontWeights.SemiBold,
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                          width: "fit-content",
                          opacity: 1,
                        }}>
                          {eventData.eventDetails.eventType.toLowerCase() === "online" ? (
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#2555EF" strokeWidth="2"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="#2555EF" strokeWidth="2"/></svg>
                          ) : (
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#2555EF" strokeWidth="2" strokeLinejoin="round"/><circle cx="12" cy="9" r="2.5" stroke="#2555EF" strokeWidth="2"/></svg>
                          )}
                          {eventData.eventDetails.eventType}
                        </span>
                      )}
                      {eventData?.eventDetails?.eventAddress?.formattedAddress && eventData?.eventDetails?.eventType !== "online" && (
                        <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, display: "flex", alignItems: "center", gap: 4, opacity: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          📍 {eventData.eventDetails.eventAddress.formattedAddress}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()
            )}
            {eventData?.multiEvents && eventData?.eventDetails?.eventAddress?.formattedAddress && (
              <>
                <span>
                  {eventData?.eventDetails?.eventType === "online"
                    ? "Virtual Address"
                    : "Location"}
                </span>
                <p>{eventData?.eventDetails?.eventAddress?.formattedAddress}</p>
              </>
            )}
          </EventTypeDetails>
        </EventType>
        {(() => {
          const descContent = eventData?.description?.replace(/&lt;/g, "<");
          const hasDesc = descContent && descContent !== "<p></p>\n" && descContent.trim() !== "";
          if (!hasDesc) return null;
          return (
            <Description>
              <span>Description</span>
              <DescriptionText>
                <div className="drawer_description">
                  <p dangerouslySetInnerHTML={{ __html: descContent }}></p>
                </div>
              </DescriptionText>
            </Description>
          );
        })()}
        {(() => {
          const ci = eventData?.eventDetails?.contactInfo;
          const hasContact = ci?.firstName || ci?.lastName ||
            (ci?.showEmail && ci?.email) ||
            ci?.facebook || ci?.instagram || ci?.twitter;
          if (!hasContact) return null;
          return (
            <>
              <ContactTitle>Contact Info</ContactTitle>
              <ContactInfo>
          <ContactInfoDetails>
            {(ci?.firstName || ci?.lastName) && (
              <>
                <span style={{ paddingRight: 10 }}>Name</span>
                <p style={{ width: "150px" }}>
                  {ci?.firstName} {ci?.lastName}
                </p>
              </>
            )}
            {ci?.showEmail && (
              <>
                <span
                  style={{ paddingRight: 10, paddingLeft: (!isMobile && (ci?.firstName || ci?.lastName)) ? 20 : 0 }}
                >
                  Email
                </span>
                <p>{ci?.email}</p>
              </>
            )}
          </ContactInfoDetails>
          <SocialIcons>
            {eventData?.eventDetails?.contactInfo?.facebook && (
              <a
                href={`${checkAndModifyUrl(
                  eventData?.eventDetails?.contactInfo?.facebook
                )}`}
                rel="noreferrer"
              >
                <Facebook />
              </a>
            )}
            {eventData?.eventDetails?.contactInfo?.instagram && (
              <a
                href={`${checkAndModifyUrl(
                  eventData?.eventDetails?.contactInfo?.instagram
                )}`}
                rel="noreferrer"
              >
                <Instagram />
              </a>
            )}
            {eventData?.eventDetails?.contactInfo?.twitter && (
              <a
                href={`${checkAndModifyUrl(
                  eventData?.eventDetails?.contactInfo?.twitter
                )}`}
                rel="noreferrer"
              >
                <Twitter />
              </a>
            )}
          </SocialIcons>
              </ContactInfo>
            </>
          );
        })()}
        <DashLine />
        {!eventData.freeEvent && (
          <PayDetails>
            {[...(eventData?.eventPricing?.prices || [])]
              .sort((a, b) => {
                const getOrder = (item) => {
                  if (item?.type === "onRegistration") return 0;
                  if (item?.isRequired) return 1;
                  return 2;
                };
                return getOrder(a) - getOrder(b);
              })
              .map((item, index) =>
              item?.type === "onRegistration" ? (
                !eventData.freeEvent && (
                  <>
                    <li key={index}>
                      {item?.title}
                      <span>
                        {item?.variant
                          ? item?.variantAmountRange?.replaceAll("$", currency)
                          : item?.openAmount || item?.type === "openAmount"
                          ? numberFormat({ number: +(item?.minimumOpenAmount || 0), decimal: 2, style: "currency" })
                          : numberFormat({
                              number: +item.amount,
                              decimal: 2,
                              style: "currency",
                            })}
                      </span>
                    </li>
                    <Note>{item?.note}</Note>
                    <hr />
                  </>
                )
              ) : (
                <>
                  <li key={index}>
                    {item?.title} {item?.type === "optional" && !item?.isRequired && `(optional)`}
                    <span>
                      {item?.openAmount || item?.type === "openAmount"
                        ? numberFormat({ number: +(item?.minimumOpenAmount || 0), decimal: 2, style: "currency" })
                        : item?.amount > 0
                        ? `${numberFormat({
                            number: +item.amount,
                            decimal: 2,
                            style: "currency",
                          })}`
                        : item?.variantAmountRange
                        ? item?.variantAmountRange?.replaceAll("$", currency)
                        : numberFormat({ number: 0, decimal: 2, style: "currency" })}
                    </span>
                  </li>
                  <Note>{item?.note}</Note>
                  <hr />
                </>
              )
            )}
            {(viewPayDetails || eventData?.multiEventsType === "individual") &&
              eventData?.eventDiscount?.map((item, index) => (
                <>
                  <li
                    key={index}
                    className={`d-flex flex-column gap-2 ${
                      item?.forMemberOnly && !isAuthenticated
                        ? "opacity-50"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      {item?.discount_name}
                      {item?.discount_type === "date" &&
                        ` | ${formatDate({
                          date: item?.start_date,
                          formatType: "defaultWithUTC",
                        })}
                                    -${formatDate({
                                      date: item?.end_date,
                                      formatType: "defaultWithUTC",
                                    })}`}
                      <span>
                        {item?.price_type === "percentage"
                          ? `${item?.value}%`
                          : `${numberFormat({
                              number: +item?.value,
                              decimal: 2,
                              style: "currency",
                            })}`}
                      </span>
                    </div>
                    {item?.forMemberOnly && !isAuthenticated && (
                      <span style={{ fontSize: Fonts.GeneralCaptionFont.fontSize }}>(Members Only)</span>
                    )}
                  </li>
                  <hr />
                </>
              ))}
            {viewPayDetails && eventData?.multiEventsType !== "individual" && (
              <>
                <TotalPay>
                  TOTAL PAYMENT
                  <span>
                    {(() => {
                      const ticketTotal = calculation.calculateTotalPaymentWithCVFee(
                        eventData,
                        totalTicketVariant,
                        "event",
                        isAuthenticated
                      );
                      const prices = eventData?.eventPricing?.prices || [];
                      const ticketCount = totalTicketVariant.reduce((sum, v) => sum + (v.selectedQuantity || 0), 0);
                      const requiredAddonPerTicket = prices.reduce((sum, p) => {
                        if (p.type === "onRegistration" || !p.isRequired) return sum;
                        if (p.variant && p.variantInfo) {
                          const amounts = Object.values(p.variantInfo).map(v => v?.openAmount ? (v?.minimumOpenAmount || 0) : (v?.amount || 0)).filter(a => a > 0);
                          return sum + (amounts.length ? Math.min(...amounts) : 0);
                        }
                        if (p.type === "openAmount" || p.openAmount) return sum + (p.minimumOpenAmount || 0);
                        return sum + (p.amount || 0);
                      }, 0);
                      return numberFormat({ number: Math.max(0, +ticketTotal + requiredAddonPerTicket * ticketCount), decimal: 2, style: "currency" });
                    })()}
                  </span>
                </TotalPay>
                <hr />
              </>
            )}
          </PayDetails>
        )}

        <br />

      </RightSideContent>
      <FixedBottomSection>
        <TicketContainer>
          {eventData?.multiEventsType === "individual" ? (
            <TicketCards
              ticketList={{
                title: "Tickets",
                variantInfo: [{
                  name: "Number of Tickets",
                  selectedQuantity: numberOfTickets.length,
                  infiniteQuantity: eventData?.eventDetails?.infiniteCapacity || false,
                  quantity: eventData?.eventDetails?.maximumCapacity || 999,
                  amount: 0,
                  forMemberOnly: false,
                }]
              }}
              handleQuantityChange={(variantIndex, value, type) => {
                if (type === "increment") handleIndividualAddTicket();
                else handleIndividualRemoveTicket();
              }}
              totalTicket={numberOfTickets?.length}
              allowNonMembers={eventData?.allowNonMembers}
            />
          ) : (
            ticketData.map((group, groupIndex) =>
              group?.variantInfo ? (
                <TicketCards
                  key={groupIndex}
                  ticketList={group}
                  handleQuantityChange={(variantIndex, value, type) =>
                    handleQuantityChange(groupIndex, variantIndex, value, type)
                  }
                  totalTicket={numberOfTickets?.length}
                  allowNonMembers={eventData?.allowNonMembers}
                  onContinue={handleReserveButton}
                  reserveButtonLabel={eventData?.buttonLabel || 'Reserve Seats'}
                  reserveButtonDisabled={
                    (!eventData?.allowNonMembers && !isAuthenticated) ||
                    isExpiredClass() ||
                    isExpiredEvent() ||
                    !numberOfTickets?.length ||
                    loading
                  }
                  reserveButtonLoading={loading}
                />
              ) : null
            )
          )}
        </TicketContainer>
      </FixedBottomSection>
      <ReserveAction isFromApp={isFromApp}>
        {memberPortal && !(isFromApp && isAuthenticated) ? (
          <ReserveLoginButton onClick={handleReserveLogin}>
            {reserveLoginButton}
          </ReserveLoginButton>
        ) : (
          <div></div>
        )}
        <ReserveButton
          onClick={handleReserveButton}
          disabled={
            (!eventData?.allowNonMembers && !isAuthenticated) ||
            isExpiredClass() ||
            isExpiredEvent() ||
            !numberOfTickets?.length ||
            loading
          }
          disabledButton={
            (!eventData?.allowNonMembers && !isAuthenticated) ||
            isExpiredClass() ||
            isExpiredEvent() ||
            !numberOfTickets?.length ||
            loading
          }
        >
          {loading ? (
            <PulseLoader color={"#fff"} size={"7px"} />
          ) : (
            eventData?.buttonLabel || "Reserve Seats"
          )}
        </ReserveButton>
      </ReserveAction>
    </RightSideWrappr>
    </>
  );
};
